export enum TokenCategory{
    Complex = 'Complex',
    Simple = 'Simple',
    Monthly = 'Monthly',
    HubMobile = 'HubMobile',
    RegistrationConclusion = 'RegistrationConclusion',
}
